import * as React from 'react';
import { observer } from 'mobx-react';

import { usePageTitle } from '~components/DashboardWrapper/PageTitle';
import { t } from '~/i18n';
import { ConfigurationForm } from '../../containers/ConfigurationForm/ConfigurationForm';
import { SiteDeveloperSettings } from '~/modules/sites/components/SiteDeveloperSettings';
import { useStores } from '~store/utils';
import { Panel, Spinner, TabsPanel } from '@ixicare/ui';

const ConfigurationPage = observer(() => {
  usePageTitle(t('menu.dashboard.configuration'));
  const { sites, permissions } = useStores();
  const siteUuid = sites.selectedSite?.uuid;
  const canManageIntegrations = permissions.has('can_manage_integrations');

  const tabs = React.useMemo(
    () => [
      { label: t('menu.dashboard.sectionGeneral'), id: 'general', content: <ConfigurationForm /> },
      ...(canManageIntegrations && siteUuid
        ? [
            {
              label: t('site.tabs.developer'),
              id: 'developer',
              content: <SiteDeveloperSettings key={siteUuid} siteUuid={siteUuid} />,
            },
          ]
        : []),
    ],
    [canManageIntegrations, siteUuid]
  );

  // TabsPanel only reads the hash when it mounts: without waiting, a link straight to #developer
  // falls back to the first tab before the permission and site that show it have arrived.
  if (!permissions.loaded || !siteUuid) {
    return <Spinner label={t('global.loading')} />;
  }

  return (
    <Panel>
      <TabsPanel tabs={tabs} useHash={true} />
    </Panel>
  );
});

export default ConfigurationPage;
